import React from 'react'

export default function ResourceContainer({
  resource,
  resourceName,
  fixedParams = {},
  customParams = {},
  loadingComponent: LoadingComponent = null,
  errorComponent: ErrorComponent = null,
  children,
  ...props
}) {
  const [customFilterParams, setCustomFilterParams] =
    React.useState(customParams)
  const firstRender = React.useRef(true)

  function customFilterParamsHandler(params) {
    setCustomFilterParams({ ...customFilterParams, ...params })
  }

  const {
    data,
    status,
    isError,
    isFetching,
    isLoading,
    isSuccess,
    error,
    ...rest
  } = resource({ params: customFilterParams })

  const isPending = status === 'pending'

  return React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        resource: {
          data: data,
          status,
          isError,
          isFetching,
          isPending,
          isLoading,
          isSuccess,
          error,
          resourceName: resourceName,
          customFilterParamsHandler,
          customFilterParams,
        },
        ...props,
      })
    }
  })
}
